<template>
  <div
    data-test="result-status-not-found"
    class="results-status text-center"    
  >
    <slot >{{ $localize('NoResultsFound') }}</slot>
  </div>
</template>